import ReactRoute from "./reactRoute/ReactRoute";

function App() {
  return (
    <div className="App">
      <ReactRoute />
    </div>
  );
}

export default App;